(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('VirtualNumberSearch', VirtualNumberSearch);

    VirtualNumberSearch.$inject = ['$resource'];

    function VirtualNumberSearch($resource) {
        var resourceUrl =  'api/_search/virtual-numbers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
